import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { InactivityService } from '../../../../app/shared/service/inactivity-service/inactivity.service';

@Injectable({
  providedIn: 'root',
})
export class SessionExpiredGuard implements CanActivate {
  constructor(private inactivityService: InactivityService, private router: Router) {}

  canActivate(): boolean {
    if (this.inactivityService.isSessionExpired()) {
      this.router.navigate(['/sessionexpired']);
      return false;
    }
    return true;
  }
}